import classNames from "classnames";
import { inject } from "mobx-react";
import React, { useMemo } from "react";
import type { Store } from "../../../../client/stores";
import type { PublishRecordFragment } from "../../../core/generated/webapi.g";
import { reverseRoute } from "../../../core/lib/route";
import { MagicLink } from "../../../core/ui";
import { getCoastLinks } from "../lib";
import "./CoastLinkedItems.style.scss";

interface CoastLinkedHostProps {
    item: PublishRecordFragment;
    titleOnSameLine: boolean;
    store?: Store;
}

export const CoastLinkedHost = inject("store")(({ store, item, titleOnSameLine }: CoastLinkedHostProps) => {
    if (!store) {
        return null;
    }

    const host = useMemo(() => getCoastLinks(item, "hosts")?.[0], [item]);

    if (!host) {
        return null;
    }

    const hostUrl = reverseRoute(store.site, "hosts_detail", { slug: host.slug }) || "#";

    const className = classNames("coast-linked-host coast-linked-items", { "title-on-same-line": titleOnSameLine });

    return (
        <p className={className}>
            <span className="linked-header">Host{titleOnSameLine ? ":" : ""}</span>
            <span className="linked-value">
                <MagicLink to={hostUrl} context={host.slug}>
                    {host.summary.title}
                </MagicLink>
            </span>
        </p>
    );
});
